module.exports = __webpack_public_path__ + "img/1586035332.b8f2fe3a.jpg";